import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Button,
  Label,
} from "reactstrap";
import { DataTable, TableRowField, ExportCSV } from "../../../../components";
import { messages, layout, roles } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { formatHelper } from "../../../../common/helpers";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import {
  getDetailedSellsReport,
  resetDetailedSellsReport,
} from "../../../../store/report/actions";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { MainLoader } from "../../../../components";

class DetailedReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null,
      startDate: null,
      endDate: null,
      focusedInput: null,
      showCard: true,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  handleEmployeesBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });
  }

  handleDateChange(selectedDate) {
    this.setState({ selectedDate });
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
  }

  async componentDidMount() {
    await this.setState({ selectedDate: moment() });
    await this.props.getStores({ reset: true });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      await this.setState({ selectedStore: this.props.stores[0] });
      this.handleDateChange(this.state.selectedDate);
    }
    this.checkExport(prevProps);
  }

  async checkExport(prevProps) {
    if (
      !prevProps.detailedSellsExportValue &&
      this.props.detailedSellsExportValue
    ) {
      const { startDate, endDate } = this.state;
      const wb = XLSX.read(this.props.detailedSellsExportValue.data, {
        type: "binary",
      });
      var storeName = this.state.selectedStore.label;
      storeName = String(storeName).replace(/\s/g, "_");
      const wbName =
        this.state.selectedStore.value == 0
          ? formatHelper.toDateYYMMDD(startDate._d) +
            "_" +
            formatHelper.toDateYYMMDD(endDate._d) +
            "_reporte-general-detalle-venta"
          : storeName.toLowerCase() +
            "_" +
            formatHelper.toDateYYMMDD(startDate._d) +
            "_" +
            formatHelper.toDateYYMMDD(endDate._d) +
            "_reporte-detalle-venta";
      XLSX.writeFile(wb, wbName + ".xlsx");
      await this.props.getDetailedSellsReport({
        startDate: null,
        endDate: null,
        storeId: null,
        reset: true,
      });
    } else if (
      !prevProps.detailedSellsExportValueError &&
      this.props.detailedSellsExportValueError
    )
      toast.error(this.props.detailedSellsExportValueError);
  }

  handleObtainReportExport() {
    this.props.getDetailedSellsReport({
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      storeId: this.state.selectedStore.value,
    });
  }

  handleExportCSV() {
    const { startDate, endDate } = this.state;
    var csvRow = [];
    var A = [
      [
        "",
        "Fecha Venta",
        "Estado Venta",
        "Tipo de Comprobante",
        "Correlativo",
        "Tipo de Pago",
        "Tipo de Tarjeta",
        "Pago Efectivo",
        "Vuelto",
        "Pago Tarjeta",
        "Valor Venta",
        "Nombre Cliente",
        "Email",
        "Numero",
        "Detalle",
        "Detalle Adicional",
        "Categoría",
        "Precio Detalle",
        "Descuento realizado",
        "Precio Después de Descuento",
        "Empleado",
      ],
    ];
    var re = this.state.detailedSellsExport;
    var storeName = this.state.selectedStore.label;
    storeName = String(storeName).replace(/\s/g, "_");

    for (var item = 0; item < re.length; item++) {
      A.push([
        item + 1,
        re[item].created_at,
        re[item].state,
        re[item].receipt_type,
        re[item].receipt_id,
        re[item].sell_payment_type,
        re[item].card_type,
        re[item].cash_payed,
        re[item].change,
        re[item].card_payed,
        re[item].total_net,
        re[item].customer,
        re[item].email,
        re[item].cellphone,
        re[item].detail_name,
        re[item].extra_detail,
        re[item].category,
        re[item].unit_price,
        re[item].unit_discount,
        re[item].price_after_discount,
        re[item].employees,
      ]);
    }
    for (var item = 0; item < A.length; item++) {
      csvRow.push(A[item].join(","));
    }
    var csvString = csvRow.join("\r\n");
    storeName = String(storeName).replace(/\s/g, "_");

    var a = document.createElement("a");
    a.href =
      "data:attachment/csv;charset=utf-16le,%EF%BB%BF" + encodeURI(csvString);
    a.target = "_Blank";
    a.download =
      this.state.selectedStore.value == 0
        ? // formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          "_reporte-general-detalle-venta" +
          ".csv"
        : // formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          storeName.toLowerCase() +
          "_" +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          "_reporte-detalle-venta" +
          ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  render() {
    const { startDate, endDate } = this.state;
    const { detailedSellsExportValueLoading } = this.props;

    if (detailedSellsExportValueLoading) {
      return <MainLoader />;
    }
    return (
      <div>
        <Card>
          <CardHeader
            onClick={() => this.setState({ showCard: !this.state.showCard })}
          >
            <i className="icon-chart"></i>Reporte Detallado de Venta
          </CardHeader>
          <CardBody>
            <div>
              {(this.props.role == roles.SUPER_ADMIN ||
                this.props.role == roles.ADMIN) && (
                <Row className="my-4">
                  <Col sm="1">
                    <Label className="mt-2">Tienda:</Label>
                  </Col>

                  <Col sm="4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={this.props.loadingStores}
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder=""
                      options={this.props.stores}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleStoreChange}
                      value={this.state.selectedStore}
                      isDisabled={
                        this.props.loadingStores ||
                        detailedSellsExportValueLoading
                      }
                    />
                  </Col>
                </Row>
              )}
              <hr className="my-4" />
              <Row className="mb-2">
                <Col md="12">
                  <DateRangePicker
                    startDate={startDate}
                    startDateId="startDate"
                    endDate={endDate}
                    endDateId="endDate"
                    displayFormat={"DD/MM/YYYY"}
                    onDatesChange={({ startDate, endDate }) =>
                      this.handleEmployeesBalanceDateChange(startDate, endDate)
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    startDatePlaceholderText="Fecha Inicio"
                    endDatePlaceholderText="Fecha Fin"
                    small
                    isOutsideRange={() => false}
                    hideKeyboardShortcutsPanel
                    numberOfMonths={1}
                    minimumNights={0}
                  />
                  {(this.state.startDate && this.state.endDate) ||
                  this.state.selectedDate ? (
                    <ExportCSV exportCSV={this.handleObtainReportExport} />
                  ) : null}
                </Col>
              </Row>
            </div>
            <hr className="my-4" />
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { detailedSellsReport } = state.report;

  return {
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
    detailedSellsExportValue: detailedSellsReport.value,
    detailedSellsExportValueLoading: detailedSellsReport.loading,
    detailedSellsExportValueError: detailedSellsReport.error,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStores,
      getDetailedSellsReport,
      resetDetailedSellsReport,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailedReport);



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/DetailedReport/DetailedReport.js